<template>
  <div class="pagination">
    <div class="buttons-wrapper" v-if="!loading">
      <button class="to-first" :class="{invalid : isFirstPage}" @click="jumpPage('first')" v-bind:disabled="isFirstPage">
        <img src="../../../assets/img/arrow-to-first.svg" />
        <!-- <font-awesome-icon icon="chevron-left" />
        <font-awesome-icon icon="chevron-left" />-->
      </button>

      <button class="to-previous" :class="{invalid : isFirstPage}" @click="flipPage('prev')" v-bind:disabled="isFirstPage">
        <img src="../../../assets/img/arrow-to-previous.svg" />
        <!-- <font-awesome-icon icon="chevron-left" /> -->
      </button>

      <div class="page-number">
        <span v-if ="!isDetail" class="mobile">
          {{
            `${currentID} - ${lastID}`
          }}
        </span>
        <span v-else class="mobile">
          {{
            `${currentPage} / ${totalPage}`
          }}
        </span>
      </div>

      <button class="to-next" :class="{invalid : isLastPage}" @click="flipPage('next')" v-bind:disabled="isLastPage">
        <img src="../../../assets/img/arrow-to-next.svg" />
        <!-- <font-awesome-icon icon="chevron-right" /> -->
      </button>

      <button class="to-end" :class="{invalid : isLastPage}" @click="jumpPage('last')" v-bind:disabled="isLastPage">
        <img src="../../../assets/img/arrow-to-end.svg" />
        <!-- <font-awesome-icon icon="chevron-right" />
        <font-awesome-icon icon="chevron-right" />-->
      </button>
    </div>

    <div v-if="loading">
      <RotateLoader :loading="loading" color="#0393f4" size="13px" />
    </div>
  </div>
</template>

<script>
import RotateLoader from "./RotateLoader.vue";
export default {
  props: ["minID", "currentID", "maxID", "lastID", "isDetail", "loading", "lastPage", "firstPage", "currentPage", "totalPage"],
  components: {
    RotateLoader,
  },
  computed: {
    isLastPage() {
      return this.lastPage
    },
    isFirstPage() {
      return this.firstPage
    }
  },
  methods: {
    flipPage(direction) {
      this.$emit("flip", direction);
    },
    jumpPage(direction) {
      this.$emit("flip", direction);
    },
  },
};
</script>

<style lang="scss">

@media screen and (max-width: 768px) {
  .mobile {
    display: none;
  }
}

%flexBox {
  display: flex;
  justify-content: center;
  align-items: center;
}

@mixin flipButton($direction) {
  width: 38px;
  margin-#{$direction}: 30px;
}

@mixin jumpButton($radius-direction, $collapse-direction) {
  width: 52px;
  border-top-#{$radius-direction}-radius: 20.5px;
  border-bottom-#{$radius-direction}-radius: 20.5px;
  border-#{$collapse-direction}: none;
}

.pagination {
  @extend %flexBox;

  margin: 30px 0 40px;

  & > div {
    @extend %flexBox;

    height: 40px;
  }
}

.buttons-wrapper {
  button {
    @extend %flexBox;

    height: 100%;
    border: solid 1px #ebebeb;
    background-color: #ffffff;
    cursor: pointer;
  }

  .to-previous {
    @include flipButton(right);
  }

  .to-next {
    @include flipButton(left);
  }

  .to-first {
    @include jumpButton(left, right);
  }

  .to-end {
    @include jumpButton(right, left);
  }

  .invalid {
    cursor: not-allowed;
    opacity: 0.4;
  }

  .page-number {
    @extend %flexBox;

    font-weight: bold;
    font-size: 13px;
    color: #666666;

    span:nth-child(2) {
      margin: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contents/shared/Pagination.vue